import { http } from './http'

export async function loginApi (payload) {
  const res = await http.post('/api/user/login', payload)
  return res.data
}

export async function refreshApi (refreshToken) {
  const res = await http.post('/api/user/refresh', { refresh_token: refreshToken })
  return res.data
}




// WEBPACK FOOTER //
// ./src/api/auth.js